<div class="col-12 px-0">
  <p class="page-header">Statement Report</p>
</div>
<form [formGroup]="searchForm">
  <div class="row mt-5">
    <div class="col-6 col-md-2 offset-md-1 form-group">
      <mat-form-field>
        <input matInput [matDatepicker]="fromDate" placeholder="From date" formControlName="fromDate" readonly (click)="togglePicker(fromDate)"
        />
        <mat-datepicker-toggle matSuffix [for]="fromDate"></mat-datepicker-toggle>
        <mat-datepicker panelClass="greengo" #fromDate></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="col-6 col-md-2 form-group">
      <mat-form-field>
        <input matInput [matDatepicker]="toDate" placeholder="To date" formControlName="toDate" readonly (click)="togglePicker(toDate)"
        />
        <mat-datepicker-toggle matSuffix [for]="toDate"></mat-datepicker-toggle>
        <mat-datepicker panelClass="greengo" #toDate></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="col-6 col-md-2 form-group">
      <button type="button" class="btn btn-block btn-lg" (click)="searchReport()" [ngClass]="{
        'btn-greengo': !(searchForm.get('fromDate').value && searchForm.get('toDate').value && searchForm.get('fromDate').value > searchForm.get('toDate').value),
        'btn-inactive': searchForm.get('fromDate').value && searchForm.get('toDate').value && searchForm.get('fromDate').value > searchForm.get('toDate').value
      }" npFocusOutClicked>Search</button>
    </div>

    <div class="col-md-2 d-md-block d-none">
      <button type="button" class="btn btn-block btn-lg btn-greengo" (click)="orderColumnOption()" npFocusOutClicked>
        Customise View
      </button>
    </div>

    <div class="col-6 col-md-2 form-group">
      <button class="btn btn-block btn-lg btn-greengo" (click)="downloadStatementPDF(false)" npFocusOutClicked>Download</button>
    </div>

    <div class="col-12 col-md-2 offset-md-9 form-group" *ngIf="showConsolidatedDownload">
      <button class="btn btn-block btn-lg btn-greengo" (click)="downloadStatementPDF(true)" npFocusOutClicked>Download consolidated report</button>
    </div>

    <div class="col-12 d-md-none d-block">
      <button type="button" class="btn btn-block btn-lg btn-greengo" (click)="orderColumnOption()" npFocusOutClicked>
        Customise View
      </button>
    </div>
  </div>

  <div class="row columns-selection-container mt-3" *ngIf="showOrderColumn">

    <div class="col-md-6 form-group">
      <div class="drag-container">
        <div class="section-heading">Visible columns</div>
        <div cdkDropList #doneList="cdkDropList" [cdkDropListData]="visibleColumns" [cdkDropListConnectedTo]="[pendingList]" class="item-list"
          (cdkDropListDropped)="drop($event)">
          <div class="item-box" *ngFor="let item of visibleColumns" cdkDrag>{{ item }}</div>
        </div>
      </div>

    </div>
    <div class="col-md-6 form-group">
      <div class="drag-container">
        <div class="section-heading">Hidden columns</div>

        <div cdkDropList #pendingList="cdkDropList" [cdkDropListData]="hiddenColumns" [cdkDropListConnectedTo]="[doneList]" class="item-list"
          (cdkDropListDropped)="drop($event)">
          <div class="item-box" *ngFor="let item of hiddenColumns" cdkDrag>{{ item }}</div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-3 ml-auto">
          <button class="btn btn-block btn-lg btn-greengo" (click)="updateColumns()" npFocusOutClicked>
            Confirm
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
<div class="statement-container" *ngIf="!isLoading">
  <div class="header--wrapper row justify-content-between">
    <div class="col-12 col-md-6 main-header-left">
      <div class="row no-gutters">
        <div class="left-panel col-3">
          Client name
        </div>
        <div class="right-panel col-9">
          {{ clientInformation?.leadName }}
        </div>
      </div>
      <div class="row no-gutters">
        <div class="left-panel col-3">
          Client address
        </div>
        <div class="right-panel col-9">
          {{ clientInformation?.leadAddress }}
        </div>
      </div>
      <div class="row no-gutters">
        <div class="left-panel col-3">
          Account No.
        </div>
        <div class="right-panel col-9">
          {{ clientInformation?.leadCode }}
        </div>
      </div>
      <div class="row no-gutters">
        <div class="left-panel no-padding-right col-3">
          Reporting period
        </div>
        <div class="right-panel col-9">
          {{ searchForm.get('fromDate').value | date : 'dd/MM/yyyy' }} - {{ searchForm.get('toDate').value | date : 'dd/MM/yyyy' }}
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-6 mb-2">
      <div class="input--border">
        Historic Trades
      </div>
    </div>
  </div>
  <div class="mb-5 table-report">
    <ng-table (cellClicked)="onCellClick($event)" [rows]="rows" [columns]="columns" [showSorting] = "false">
    </ng-table>
  </div>

  <div class="row">
    <div class="col-md-6 mb-2">
      <div class="input--border">
        Outstanding Trades
      </div>
    </div>
  </div>
  <div class="mb-5 table-report">
    <ng-table (cellClicked)="onCellClick($event)" [rows]="rowsOutstanding" [columns]="columnsOutstanding" [showSorting] = "false">
    </ng-table>
  </div>

  <div class="row">
    <div class="col-md-6">
      <div class="input--border">
        Balance Summary
      </div>
    </div>
  </div>

  <div class="row mb-5">
    <div class="col-12 normal-table">
      <ng-table (cellClicked)="onCellClickBalanceSummary($event)" [rows]="rowsBalanceSummary" [columns]="columnsBalanceSummary" [showSorting] = "false">
      </ng-table>
    </div>
  </div>

  <div *ngFor="let balanceDetail of balanceDetails, let i = index" class="row">
    <div  class="col-lg-12 col-xl-6"  [hidden]="balanceDetail.isHidden">
      <div class="input--border">{{ balanceDetail.ccy }} Balance Breakdown</div>
      <div class="normal-table mb-5">
        <ng-table [rows]="balanceDetail.outstandingTransactions" [columns]="columnsBalanceDetail" [maxHeight]="50" [showCheckbox] = "false" [showSorting] = "false">
        </ng-table>
      </div>
    </div>
    <div  class="col-lg-12 col-xl-6"  [hidden]="balanceDetail.isHidden">
      <div class="input--border">{{ balanceDetail.ccy }} Pending Balance Breakdown</div>
      <div class="normal-table mb-5">
        <ng-table [rows]="balanceDetail.pendingTransactions" [columns]="columnsBalanceDetail" [maxHeight]="50" [showCheckbox] = "false" [showSorting] = "false">
        </ng-table>
      </div>
    </div>
  </div>
</div>
